import { render, staticRenderFns } from "./ClustersCreatePage.vue?vue&type=template&id=1b8aa280&scoped=true&"
import script from "./ClustersCreatePage.vue?vue&type=script&lang=js&"
export * from "./ClustersCreatePage.vue?vue&type=script&lang=js&"
import style0 from "./ClustersCreatePage.vue?vue&type=style&index=0&id=1b8aa280&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8aa280",
  null
  
)

export default component.exports